import React from 'react';
import { Link } from 'react-router-dom';
import { RDReadyLogo } from './RDReadyLogo';
export function RDReadyFooter() {
  return <footer className="border-t border-[#EDF1F7] bg-[#F7F9FC] px-5 py-12 text-[#475569] md:px-8" style={{
    fontFamily: '"Poppins", "Inter", system-ui, sans-serif'
  }} data-id="element-3733">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-[1.5fr_1fr_1fr]" data-id="element-3734">
        <div data-id="element-3735">
          <Link to="/" className="inline-flex" aria-label="RD Ready home" data-id="element-3736">
            <RDReadyLogo className="h-9 w-40" data-id="element-3737" />
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#64748B]" data-id="element-3738">
            Evidence-based study tools built by dietitians to help you pass the
            RD and CNSC certification exams with confidence.
          </p>
        </div>
        <div data-id="element-3739">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0F172A]" data-id="element-3740">
            Explore
          </p>
          <div className="mt-4 flex flex-col gap-2.5 text-sm" data-id="element-3741">
            <Link to="/rd-exam" className="transition-colors hover:text-[#2563EB]" data-id="element-3742">
              RD Exam Prep · $150
            </Link>
            <Link to="/cnsc-exam" className="transition-colors hover:text-[#2563EB]" data-id="element-3743">
              CNSC Exam Prep · $150
            </Link>
            <Link to="/study" className="transition-colors hover:text-[#2563EB]" data-id="element-3744">
              Study Space
            </Link>
            <Link to="/account" className="transition-colors hover:text-[#2563EB]" data-id="element-3745">
              Account
            </Link>
          </div>
        </div>
        <div data-id="element-3746">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0F172A]" data-id="element-3747">
            Important note
          </p>
          <p className="mt-4 text-sm leading-relaxed text-[#64748B]" data-id="element-3748">
            RD Ready is an independent study resource. It is not affiliated
            with, endorsed by, or a guarantee of success on any certification
            examination.
          </p>
        </div>
      </div>
      <div className="mx-auto mt-10 flex max-w-7xl flex-col gap-3 border-t border-[#E2E8F0] pt-6 text-xs text-[#94A3B8] md:flex-row md:justify-between" data-id="element-3749">
        <span data-id="element-3750">
          © {new Date().getFullYear()} RD Ready. All rights reserved.
        </span>
        <div className="flex gap-5" data-id="element-3751">
          <Link to="/privacy" className="transition-colors hover:text-[#2563EB]" data-id="element-3752">
            Privacy
          </Link>
          <Link to="/terms" className="transition-colors hover:text-[#2563EB]" data-id="element-3753">
            Terms
          </Link>
        </div>
      </div>
    </footer>;
}